import position from '../interactive-element/observables/positionObservable'
import panorama from '../interactive-element/observables/panoObservable'
import mediaProgress from '../interactive-element/observables/positionalMediaObservable'
import { observable } from 'mobx'
export default observable({
    position,
    panorama,
    mediaProgress,
})
